import styled from "styled-components";

export const H4 = styled.h4`
  font-family: Calibri;
  font-size: 24px;
  font-weight: 700;
  text-transform: capitalize
  line-height: 29.3px;
  text-align: center;
  margin: 1rem 0;

  @media (min-width: 768px) {
    font-size: 32px;
    margin: 1rem 0;
  }

  @media (min-width: 1280px) {
    font-size: 38px
  }
`

export const H5 = styled.h5`
  font-family: Calibri;
  text-transform: capitalize;
  font-size: 20px;
  font-weight: 700;
  line-height: 29.3px;
  text-align: center;
  margin: 1rem 0;

  @media (min-width: 768px) {
    font-size: 25px;
  }

  @media (min-width: 1280px) {
    font-size: 32px
  }
`

export const PTag = styled.p`
  font-family: Calibri;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.53px;
  text-align: center;
  padding: 0 1rem;

  @media (min-width: 768px) {
    font-size: 18px;
    font-weight: 400;
    line-height: 23px;
  }

  @media (min-width: 1280px) {
    font-size: 22px;
    line-height: 30px
  }
`